<template>
  <v-content>
    <v-toolbar class="bg-color" dark extended flat>
    </v-toolbar>
    <v-layout wrap column pb-2 justify-center>
      <v-flex xs12 sm10 md8>
        <v-flex xs12 d-flex justify-center>
          <v-card class="card--flex-toolbar" style="max-width:750px">
            <v-toolbar card prominent>
              <v-toolbar-title class="body-2 grey--text">Account Activated</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text>
              <v-layout wrap>
                <v-flex xs12 sm7>
                  <v-card-title class="pb-0">
                    <div>
                      <h3 class="headline mb-0">Welcome to Crio!</h3>
                      <span class="grey--text">Your account has been activated. Please sign in to enjoy a new teaching experience!</span>
                    </div>
                  </v-card-title>
                  <v-form ref="form" v-model="valid" lazy-validation>
                    <v-container fluid grid-list-md>
                      <v-layout wrap>
                        <v-layout xs12 justify-space-between class="mt-3">
                          <v-btn color="teal" class="white--text" href="https://ureply.hksyu.edu">Login to uReply</v-btn>
                          <v-btn color="teal" class="white--text" href="https://crio.hksyu.edu">Login to Crio</v-btn>
                        </v-layout>
                      </v-layout>
                    </v-container>
                  </v-form>
                </v-flex>
                <v-flex xs12 sm5 class="hidden-xs-only pt-3">
                  <v-img contain class="ma-3" src="/assets/tick.png"></v-img>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 d-flex justify-center>
        </v-flex>
      </v-flex>
    </v-layout>
  </v-content>
</template>

<script>
  export default {
    props: {
      navigateTo: Function
    },
    data() {
      return {
      };
    },
    methods: {
      goHome() {
        window.history.back();
      },
    }
  };
</script>

